export default __webpack_public_path__ + "static/media/ig.672efb4f.png";